import React from 'react'
import styled, { keyframes } from 'styled-components'

const ZigZagDiv = styled.div`
  background: var(--color-foreground);
  display: inline-block;
  width:60px;
  overflow:hidden;
  border-radius: 4px;
`

const move = keyframes`
0% {
  transform:translate(-651px , -366px);
}
100% {
  transform:translate(-711px, -366px);
}
`

const ZigZagPolyline = styled.polyline`
  animation: 4s ${move} linear infinite;
`

function ZigZag() {
  return (
    <ZigZagDiv>
      <svg width="120" height="16" viewBox="0 0 120 16" xmlSpace="preserve" >
        <ZigZagPolyline
          fill="none"
          strokeWidth="3"
          stroke="var(--color-secondary)"
          points="652.5 379 662.5 369 672.5 379 682.5 369 692.5 379 702.5 369 712.5 379 722.5 369 732.5 379 742.5 369 752.5 379 762.5 369 772.5 379"
        />
      </svg>
    </ZigZagDiv>
  )
}

export default ZigZag

